import React, { useState } from 'react'
import { Modal, Input, message } from 'antd'
import styled from 'styled-components'
import Title from 'src/branding/Title'

const { TextArea } = Input

const DeclineReasonModal = ({
  visible,
  onCancel,
  onConfirm,
  loading = false,
}) => {
  const [declineReason, setDeclineReason] = useState('')

  const handleConfirm = () => {
    if (!declineReason.trim()) {
      message.error('Please provide a reason for declining')
      return
    }
    if (declineReason.trim().length < 10) {
      message.error('Reason must be at least 10 characters long')
      return
    }
    onConfirm(declineReason.trim())
  }

  const handleCancel = () => {
    setDeclineReason('')
    onCancel()
  }

  return (
    <Modal
      visible={visible}
      onCancel={handleCancel}
      onOk={handleConfirm}
      okText='Confirm Decline'
      cancelText='Cancel'
      confirmLoading={loading}
      okButtonProps={{ danger: true }}
    >
      <Wrapper>
        <TitleWrapper>
          <Title>Decline Request</Title>
        </TitleWrapper>
        <Description>
          Please provide a reason for declining this special purchase request.
        </Description>
        <TextArea
          rows={4}
          value={declineReason}
          placeholder='Enter reason for declining (minimum 10 characters)...'
          onChange={e => setDeclineReason(e.target.value)}
          maxLength={500}
          showCount
        />
      </Wrapper>
    </Modal>
  )
}

export default DeclineReasonModal

const Wrapper = styled.div``

const TitleWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin: 5px;
`

const Description = styled.div`
  display: flex;
  justify-content: center;
  color: ${({ theme }) => theme.colours.oliveGrey};
  margin: 5px 5px 15px 5px;
  line-height: 25px;
`
